import { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import axios from "axios";
import KeycloakService from "../security/keycloak-service";

const HttpMethods = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
};

const _axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: `Bearer ${KeycloakService.GetAccesToken()}`,
  },
});

const cb = (config: InternalAxiosRequestConfig) => {
  config.baseURL = process.env.VUE_APP_API_URL;
  config.headers.Authorization = `Bearer ${KeycloakService.GetAccesToken()}`;
  return config;
};

const configureAxiosKeycloak = (): void => {
  _axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      console.log(KeycloakService.GetUserName);
      if (KeycloakService.IsLoggedIn()) {
        KeycloakService.UpdateToken(cb(config));
      }

      return config;
    }
  );
};

const getAxiosClient = (): AxiosInstance => _axios;

const HttpService = {
  HttpMethods,
  configureAxiosKeycloak,
  getAxiosClient,
};

export default HttpService;
